export const CONTRACTS_FETCH_CONTRACTS = 'CONTRACTS_FETCH_CONTRACTS'
export const CONTRACTS_FETCH_CONTRACTS_V2 = 'CONTRACTS_FETCH_CONTRACTS_V2'
export const CONTRACTS_FETCH_CONTRACT = 'CONTRACTS_FETCH_CONTRACT'
